import React from 'react';
import styled from 'styled-components';
import { Card, CardStrip, CardStateSection } from '../Card/Card';
import ErrorIcon from '../../assets/icons/warning.svg?react';

export type ErrorCardProps = {
  /**
   * Children of the component
   */
  children: React.ReactNode;
  /**
   * Width of the card
   */
  desktopWidth?: string;
};

const ErrorStateSection = styled(CardStateSection)`
  background: var(--red-200);
`;

const ErrorContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const CircularErrorIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--red-200);
  color: var(--white);
`;

/**
 * A error card component that displays content with a red error indicator and error icon.
 */
export const ErrorCard = ({ children, desktopWidth }: ErrorCardProps) => {
  return (
    <Card desktopWidth={desktopWidth}>
      <CardStrip $backgroundColor="var(--red-400)" />
      <ErrorContentContainer>
        <ErrorStateSection>
          <CircularErrorIconContainer>
            <ErrorIcon width={24} height={24} aria-label="Error" />
          </CircularErrorIconContainer>
        </ErrorStateSection>
        {children}
      </ErrorContentContainer>
    </Card>
  );
};

export default ErrorCard;
